export const CALCULATED_RATE = 'CALCULATED_RATE'
export const RESET_RATE = 'RESET_RATE'
